const bespokeServerAppMockups4Html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Bespoke Server App — Style Explorations</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Poppins:wght@400;500;600;700;800;900&display=swap');

*{margin:0;padding:0;box-sizing:border-box}

body{
  background:#F5F5F5;
  color:#333;
  font-family:system-ui,-apple-system,sans-serif;
  padding:40px 20px;
}

h1{text-align:center;font-size:28px;font-weight:700;margin-bottom:8px;letter-spacing:-0.5px;color:#1a1a1a}
.subtitle{text-align:center;font-size:14px;color:#999;margin-bottom:40px}

.grid-wrapper{
  display:grid;
  grid-template-columns:80px repeat(3,375px);
  grid-template-rows:40px repeat(4,812px);
  gap:24px;
  justify-content:center;
  align-items:start;
}

.col-header{text-align:center;font-size:16px;font-weight:700;letter-spacing:1px;text-transform:uppercase;display:flex;align-items:end;justify-content:center;padding-bottom:8px}
.col-header.fitbit{color:#00B0B9}
.col-header.strava{color:#FC4C02}
.col-header.snackpass{color:#FF2D78}

.row-label{writing-mode:vertical-lr;transform:rotate(180deg);font-size:13px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#999;display:flex;align-items:center;justify-content:center}

.phone{width:375px;height:812px;border-radius:40px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,0.12),0 0 0 1px rgba(0,0,0,0.06);position:relative}

.corner{grid-column:1;grid-row:1}

.footer{text-align:center;font-size:12px;color:#999;margin-top:40px;padding-bottom:40px;line-height:1.6}

/* ================================================================
   FITBIT
   ================================================================ */
.fit{
  font-family:'Inter',system-ui,sans-serif;
  background:#FFFFFF;
  color:#1a1a1a;
  height:100%;
  display:flex;
  flex-direction:column;
}
.fit .bar{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#aaa;font-weight:500}
.fit .nav{display:flex;justify-content:space-around;padding:10px 0 28px;border-top:1px solid #eee;margin-top:auto;background:#fff}
.fit .nav span{font-size:10px;color:#aaa;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px}
.fit .nav span.on{color:#00B0B9}

.fit .title{padding:16px 24px 0;font-size:22px;font-weight:700}
.fit .sub{padding:4px 24px 12px;font-size:13px;color:#aaa;font-weight:500}

.fit .card{background:#F7F9FA;border-radius:16px;margin:8px 20px;padding:16px 20px}
.fit .card .ct{font-size:11px;font-weight:600;color:#aaa;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px}
.fit .card .cv{font-size:24px;font-weight:700}
.fit .card .cv em{font-style:normal;color:#00B0B9}
.fit .card .cs{font-size:12px;color:#aaa;margin-top:4px}

.fit .ring-wrap{display:flex;justify-content:center;padding:24px 0 16px}
.fit .ring-wrap svg{width:180px;height:180px}
.fit .rbg{fill:none;stroke:#E6F6F7;stroke-width:12}
.fit .rfg{fill:none;stroke:#00B0B9;stroke-width:12;stroke-linecap:round;transform:rotate(-90deg);transform-origin:center}
.fit .rt{font-family:'Inter',sans-serif;fill:#1a1a1a;font-weight:800;font-size:36px;text-anchor:middle}
.fit .rs{font-family:'Inter',sans-serif;fill:#aaa;font-size:12px;text-anchor:middle}

.fit .hbar{margin:0 20px;height:8px;background:#E6F6F7;border-radius:4px;overflow:hidden}
.fit .hbar .fill{height:100%;background:#00B0B9;border-radius:4px}
.fit .hbar-label{display:flex;justify-content:space-between;padding:4px 20px 0;font-size:11px;color:#aaa;font-weight:500}

.fit .stats-row{display:flex;gap:8px;padding:8px 20px}
.fit .sbox{flex:1;background:#F7F9FA;border-radius:12px;padding:12px;text-align:center}
.fit .sbox .v{font-size:18px;font-weight:700;color:#00B0B9}
.fit .sbox .l{font-size:10px;color:#aaa;margin-top:2px}

.fit .list-item{display:flex;align-items:center;gap:12px;padding:12px 24px;border-bottom:1px solid #f0f0f0}
.fit .list-item .icon{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0}
.fit .list-item .icon.teal{background:#E6F6F7;color:#00B0B9}
.fit .list-item .icon.gray{background:#f5f5f5;color:#ccc}
.fit .list-item .text{flex:1}
.fit .list-item .text .t1{font-size:13px;font-weight:600}
.fit .list-item .text .t2{font-size:11px;color:#aaa}
.fit .list-item .right{font-size:14px;font-weight:600;color:#aaa}
.fit .list-item .right.teal{color:#00B0B9}

.fit .tag{display:inline-block;padding:3px 10px;border-radius:6px;font-size:11px;font-weight:600}
.fit .tag.teal{background:#E6F6F7;color:#00B0B9}

.fit .divider{height:1px;background:#f0f0f0;margin:4px 24px}

.fit .btn{margin:8px 20px;padding:14px;border-radius:12px;text-align:center;font-size:14px;font-weight:700;cursor:pointer;border:none;font-family:'Inter',sans-serif}
.fit .btn.primary{background:#00B0B9;color:#fff}
.fit .btn.secondary{background:#E6F6F7;color:#00B0B9}

/* Fit graph */
.fit .mini-graph{display:flex;align-items:flex-end;gap:6px;height:80px;padding:12px 24px}
.fit .mini-graph .gbar{flex:1;background:#E6F6F7;border-radius:4px 4px 0 0;min-height:4px;position:relative}
.fit .mini-graph .gbar.on{background:#00B0B9}
.fit .mini-graph .gbar.hi{background:#008C94}
.fit .graph-labels{display:flex;justify-content:space-between;padding:4px 24px 0;font-size:9px;color:#aaa}

/* Fit quiz */
.fit .quiz-q{padding:12px 24px;font-size:14px;font-weight:600;color:#1a1a1a}
.fit .quiz-opt{margin:4px 24px;padding:12px 16px;background:#F7F9FA;border:2px solid #E6F6F7;border-radius:12px;font-size:13px;font-weight:500;cursor:pointer}
.fit .quiz-opt:hover{border-color:#00B0B9;background:#F0FAFA}

/* ================================================================
   STRAVA
   ================================================================ */
.stv{
  font-family:system-ui,-apple-system,sans-serif;
  background:#1C1C1E;
  color:#fff;
  height:100%;
  display:flex;
  flex-direction:column;
}
.stv .bar{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#555;font-weight:500}
.stv .nav{display:flex;justify-content:space-around;padding:10px 0 28px;border-top:1px solid #2C2C2E;margin-top:auto;background:#1C1C1E}
.stv .nav span{font-size:10px;color:#555;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px}
.stv .nav span.on{color:#FC4C02}

.stv .hero{margin:8px 16px;border-radius:16px;padding:24px;position:relative;overflow:hidden}
.stv .hero.orange{background:linear-gradient(135deg,#FC4C02 0%,#e04400 50%,#c03800 100%)}
.stv .hero.dark{background:#2C2C2E;border:1px solid #3A3A3C}
.stv .hero .tag{font-size:10px;text-transform:uppercase;letter-spacing:2px;color:rgba(255,255,255,0.6);margin-bottom:6px}
.stv .hero h2{font-size:22px;font-weight:800;line-height:1.2}
.stv .hero .sub{font-size:13px;color:rgba(255,255,255,0.65);margin-top:6px}

.stv .label{padding:16px 20px 8px;font-size:11px;font-weight:600;color:#666;text-transform:uppercase;letter-spacing:1.5px}

.stv .row-item{display:flex;align-items:center;gap:12px;padding:12px 20px;border-bottom:1px solid #2C2C2E}
.stv .row-item .ri-icon{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0}
.stv .row-item .ri-icon.orange{background:rgba(252,76,2,0.15);color:#FC4C02}
.stv .row-item .ri-icon.dim{background:#2C2C2E;color:#555}
.stv .row-item .text{flex:1}
.stv .row-item .text .t1{font-size:14px;font-weight:600}
.stv .row-item .text .t2{font-size:11px;color:#666}
.stv .row-item .right{font-size:13px;font-weight:700;color:#FC4C02}

.stv .stat-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:8px 16px}
.stv .stat-card{background:#2C2C2E;border-radius:12px;padding:14px;text-align:center}
.stv .stat-card .v{font-size:22px;font-weight:800}
.stv .stat-card .v.orange{color:#FC4C02}
.stv .stat-card .l{font-size:10px;color:#666;margin-top:2px;text-transform:uppercase}

.stv .seg-bar{height:8px;background:#2C2C2E;border-radius:4px;overflow:hidden;margin:0 20px}
.stv .seg-bar .fill{height:100%;background:linear-gradient(90deg,#FC4C02,#FF6B35);border-radius:4px}
.stv .seg-label{display:flex;justify-content:space-between;padding:6px 20px 0;font-size:10px;color:#555}

.stv .btn{margin:8px 16px;padding:14px;border-radius:12px;text-align:center;font-size:14px;font-weight:700;cursor:pointer;border:none;font-family:system-ui}
.stv .btn.solid{background:#FC4C02;color:#fff}
.stv .btn.outline{background:transparent;border:2px solid #FC4C02;color:#FC4C02}
.stv .btn.dim{background:#2C2C2E;color:#999;border:1px solid #3A3A3C}

.stv .pill{display:inline-block;padding:4px 12px;border-radius:8px;font-size:11px;font-weight:700}
.stv .pill.orange{background:rgba(252,76,2,0.15);color:#FC4C02}

.stv .toggle{display:flex;gap:0;margin:8px 20px;background:#2C2C2E;border-radius:8px;overflow:hidden}
.stv .toggle button{flex:1;padding:8px;border:none;background:transparent;font-size:12px;font-weight:600;color:#666;cursor:pointer;font-family:system-ui}
.stv .toggle button.on{background:#FC4C02;color:#fff}

/* Strava graph */
.stv .mini-graph{display:flex;align-items:flex-end;gap:6px;height:80px;padding:12px 20px}
.stv .mini-graph .gbar{flex:1;background:#2C2C2E;border-radius:4px 4px 0 0;min-height:4px}
.stv .mini-graph .gbar.on{background:#FC4C02}
.stv .mini-graph .gbar.hi{background:#e04400}
.stv .graph-labels{display:flex;justify-content:space-between;padding:4px 20px 0;font-size:9px;color:#555}

/* Strava quiz */
.stv .quiz-q{padding:12px 20px;font-size:14px;font-weight:600}
.stv .quiz-opt{margin:4px 20px;padding:12px 16px;background:#2C2C2E;border:2px solid #3A3A3C;border-radius:12px;font-size:13px;color:#ccc;font-weight:500;cursor:pointer}
.stv .quiz-opt:hover{border-color:#FC4C02}

/* ================================================================
   SNACKPASS
   ================================================================ */
.snk{
  font-family:'Poppins',system-ui,sans-serif;
  background:#FFFFFF;
  color:#1a1a1a;
  height:100%;
  display:flex;
  flex-direction:column;
}
.snk .bar{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#bbb;font-weight:600}
.snk .nav{display:flex;justify-content:space-around;padding:10px 0 28px;border-top:1px solid #f0f0f0;margin-top:auto;background:#fff}
.snk .nav span{font-size:10px;color:#bbb;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;font-weight:700}
.snk .nav span.on{color:#FF2D78}

.snk .gradient{margin:8px 16px;border-radius:24px;padding:24px;color:#fff;position:relative;overflow:hidden}
.snk .gradient.pk{background:linear-gradient(135deg,#FF2D78 0%,#FF6B9D 50%,#FFD600 100%)}
.snk .gradient.yl{background:linear-gradient(135deg,#FFD600 0%,#FFC107 100%);color:#1a1a1a}
.snk .gradient.soft{background:linear-gradient(135deg,#FFF5F8 0%,#FFF9E6 100%);color:#1a1a1a;border:2px solid #FFE0EC}
.snk .gradient .emoji-lg{font-size:40px;display:block;margin-bottom:8px}
.snk .gradient h2{font-size:20px;font-weight:800}
.snk .gradient .sub{font-size:13px;font-weight:600;margin-top:4px;opacity:0.85}

.snk .section-title{padding:14px 20px 6px;font-size:16px;font-weight:800}

.snk .bubble-row{display:flex;gap:6px;padding:8px 16px;flex-wrap:wrap;justify-content:center}
.snk .bub{display:inline-flex;align-items:center;gap:4px;padding:6px 14px;border-radius:50px;font-size:12px;font-weight:700}
.snk .bub.pk{background:#FFF0F5;color:#FF2D78}
.snk .bub.yl{background:#FFFCE6;color:#D49B00}
.snk .bub.gn{background:#E8FFE8;color:#22C55E}

.snk .feed{margin:6px 16px;background:#FAFAFA;border-radius:20px;padding:14px 16px;display:flex;align-items:center;gap:12px}
.snk .feed .emoji{font-size:28px;flex-shrink:0}
.snk .feed .text{flex:1}
.snk .feed .text .t1{font-size:13px;font-weight:700}
.snk .feed .text .t2{font-size:11px;color:#999;font-weight:500;margin-top:2px}

.snk .stamp-row{display:flex;justify-content:center;gap:10px;padding:16px 20px}
.snk .stamp{width:52px;height:52px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:22px}
.snk .stamp.done{background:linear-gradient(135deg,#FF2D78,#FF6B9D);color:#fff;box-shadow:0 4px 12px rgba(255,45,120,0.25)}
.snk .stamp.empty{background:#f5f5f5;color:#ddd;border:2px dashed #ddd}

.snk .reward-card{margin:8px 16px;background:linear-gradient(135deg,#FFF5F8,#FFF9E6);border:2px solid #FFD600;border-radius:20px;padding:16px;text-align:center}
.snk .reward-card .emoji{font-size:32px;display:block;margin-bottom:6px}
.snk .reward-card .title{font-size:14px;font-weight:800;color:#FF2D78}
.snk .reward-card .sub{font-size:11px;color:#999;margin-top:4px}

.snk .qs-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;padding:8px 16px}
.snk .qs{background:#FFF5F8;border-radius:16px;padding:12px 8px;text-align:center}
.snk .qs .v{font-size:18px;font-weight:800;color:#FF2D78}
.snk .qs .l{font-size:9px;color:#999;font-weight:600;margin-top:2px}

.snk .btn{margin:8px 16px;padding:14px;border-radius:50px;text-align:center;font-size:14px;font-weight:800;cursor:pointer;border:none;font-family:'Poppins',sans-serif}
.snk .btn.pk{background:#FF2D78;color:#fff}
.snk .btn.yl{background:#FFD600;color:#1a1a1a}

/* Snk graph */
.snk .mini-graph{display:flex;align-items:flex-end;gap:6px;height:70px;padding:8px 20px}
.snk .mini-graph .gbar{flex:1;background:#FFF0F5;border-radius:10px 10px 0 0;min-height:4px}
.snk .mini-graph .gbar.on{background:linear-gradient(180deg,#FF2D78,#FF6B9D)}
.snk .mini-graph .gbar.hi{background:linear-gradient(180deg,#FFD600,#FFC107)}
.snk .graph-labels{display:flex;justify-content:space-between;padding:4px 20px 0;font-size:9px;color:#bbb}

/* Snk quiz */
.snk .quiz-q{padding:12px 20px;font-size:14px;font-weight:700;color:#1a1a1a}
.snk .quiz-opt{margin:4px 20px;padding:14px 16px;background:#FFF5F8;border:2px solid #FFE0EC;border-radius:16px;font-size:13px;font-weight:600;cursor:pointer}
.snk .quiz-opt:hover{border-color:#FF2D78}

/* Team bar */
.team-bar{margin:0 20px;height:10px;border-radius:5px;overflow:hidden;position:relative}
.team-bar .bg{position:absolute;inset:0;border-radius:5px}
.team-bar .fill{height:100%;border-radius:5px;position:relative;z-index:1}

/* Level bar */
.level-bar{margin:0 20px;height:12px;border-radius:6px;overflow:hidden}
.level-bar .fill{height:100%;border-radius:6px}

</style>
</head>
<body>

<h1>Bespoke Server App — Style Explorations</h1>
<p class="subtitle">The Grove, San Francisco — "San Francisco's living room"</p>

<div class="grid-wrapper">
  <div class="corner"></div>
  <div class="col-header fitbit">Fitbit</div>
  <div class="col-header strava">Strava</div>
  <div class="col-header snackpass">Snackpass</div>

  <!-- ================================================================
       ROW 1: HOME / DASHBOARD
       ================================================================ -->
  <div class="row-label">Home</div>

  <!-- FITBIT HOME -->
  <div class="phone">
    <div class="fit">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="title">Good morning, Sarah</div>
      <div class="sub">Lunch Shift · 11am – 3pm</div>
      <div class="ring-wrap">
        <svg viewBox="0 0 180 180">
          <circle class="rbg" cx="90" cy="90" r="74"/>
          <circle class="rfg" cx="90" cy="90" r="74" stroke-dasharray="465" stroke-dashoffset="186"/>
          <text class="rt" x="90" y="86">3/5</text>
          <text class="rs" x="90" y="106">greeting moments</text>
        </svg>
      </div>
      <div class="card">
        <div class="ct">Team Goal — Lunch Crew</div>
        <div style="display:flex;align-items:center;gap:10px;margin-top:8px">
          <div style="flex:1">
            <div class="hbar" style="margin:0"><div class="fill" style="width:72%"></div></div>
          </div>
          <div style="font-size:14px;font-weight:700;color:#00B0B9">18/25</div>
        </div>
        <div class="cs">Hospitality moments today · 7 more to hit crew goal</div>
      </div>
      <div class="stats-row">
        <div class="sbox"><div class="v">🔥 4</div><div class="l">Day Streak</div></div>
        <div class="sbox"><div class="v">340</div><div class="l">XP Today</div></div>
        <div class="sbox"><div class="v">160</div><div class="l">XP to ☕</div></div>
      </div>
      <div class="card" style="background:#E6F6F7;border:1px solid #C5E8EA">
        <div style="display:flex;align-items:center;gap:10px">
          <span style="font-size:18px">☕</span>
          <div>
            <div style="font-size:13px;font-weight:600">160 XP away from a free coffee</div>
            <div style="font-size:11px;color:#008C94;margin-top:2px">Complete today's challenge for +200 XP</div>
          </div>
        </div>
      </div>
      <div class="nav">
        <span class="on">◉ Home</span>
        <span>◎ Prep</span>
        <span>◎ Stats</span>
      </div>
    </div>
  </div>

  <!-- STRAVA HOME -->
  <div class="phone">
    <div class="stv">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="hero dark">
        <div class="tag">Today's Activity</div>
        <h2 style="color:#FC4C02;font-size:36px">3</h2>
        <div class="sub" style="font-size:15px;color:#ccc;font-weight:600">hospitality moments</div>
        <div style="margin-top:12px">
          <div class="seg-bar" style="margin:0"><div class="fill" style="width:60%"></div></div>
          <div class="seg-label" style="padding:6px 0 0"><span>0</span><span>Goal: 5</span></div>
        </div>
      </div>
      <div style="margin:8px 16px;background:#2C2C2E;border-radius:12px;padding:14px 16px;display:flex;align-items:center;gap:12px;border:1px solid #3A3A3C">
        <span style="font-size:24px">👥</span>
        <div style="flex:1">
          <div style="font-size:13px;font-weight:700">Team Effort</div>
          <div style="font-size:11px;color:#888;margin-top:2px">Lunch crew: 18 of 25 moments</div>
        </div>
        <div style="font-size:14px;font-weight:800;color:#FC4C02">72%</div>
      </div>
      <div class="stat-grid">
        <div class="stat-card"><div class="v orange">🔥 4</div><div class="l">Day Streak</div></div>
        <div class="stat-card"><div class="v orange">340</div><div class="l">XP Today</div></div>
      </div>
      <div style="margin:8px 16px;background:#2C2C2E;border-radius:12px;padding:14px 16px;border:1px solid #3A3A3C">
        <div style="display:flex;align-items:center;gap:10px">
          <span style="font-size:20px">☕</span>
          <div style="flex:1">
            <div style="font-size:12px;font-weight:700">Free Coffee Reward</div>
            <div style="margin-top:6px;height:6px;background:#3A3A3C;border-radius:3px;overflow:hidden"><div style="width:68%;height:100%;background:linear-gradient(90deg,#FC4C02,#FF6B35);border-radius:3px"></div></div>
            <div style="font-size:10px;color:#666;margin-top:4px">340 / 500 XP · 160 more to go</div>
          </div>
        </div>
      </div>
      <div style="margin:8px 16px;padding:12px;background:rgba(252,76,2,0.1);border-radius:12px;text-align:center">
        <span style="font-size:13px;font-weight:700;color:#FC4C02">PR alert: You hit 5/5 last Tuesday — match it today?</span>
      </div>
      <div class="nav">
        <span class="on">◉ Home</span>
        <span>◎ Prep</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS HOME -->
  <div class="phone">
    <div class="snk">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="gradient pk" style="text-align:center">
        <span class="emoji-lg">☀️</span>
        <h2>Lunch Shift — Let's go!</h2>
        <div class="sub">3 of 5 greeting moments done</div>
      </div>
      <div style="padding:12px 20px 4px;text-align:center;font-size:13px;font-weight:700;color:#999">Crew Goal 🏆</div>
      <div style="margin:0 20px;display:flex;align-items:center;gap:10px">
        <div style="flex:1">
          <div class="team-bar"><div class="bg" style="background:#FFF0F5"></div><div class="fill" style="width:72%;background:linear-gradient(90deg,#FF2D78,#FF6B9D)"></div></div>
        </div>
        <div style="font-size:13px;font-weight:800;color:#FF2D78">18/25</div>
      </div>
      <div style="text-align:center;padding:4px 0;font-size:11px;color:#999;font-weight:600">👤👤👤 Sarah, Mike, Jamie — 7 more!</div>
      <div class="bubble-row" style="margin-top:8px">
        <div class="bub pk">🔥 4-day streak!</div>
        <div class="bub yl">⚡ 340 XP today</div>
      </div>
      <div class="feed">
        <div class="emoji">☕</div>
        <div class="text">
          <div class="t1">Free coffee in 160 more XP!</div>
          <div class="t2">Complete today's challenge for +200 XP</div>
        </div>
      </div>
      <div class="feed">
        <div class="emoji">🎯</div>
        <div class="text">
          <div class="t1">Personal best: 5/5 last Tuesday</div>
          <div class="t2">You're 2 away from matching it!</div>
        </div>
      </div>
      <div class="feed">
        <div class="emoji">👥</div>
        <div class="text">
          <div class="t1">Team's on a roll!</div>
          <div class="t2">Mike just hit his 4th greeting moment</div>
        </div>
      </div>
      <div class="nav">
        <span class="on">◉ Home</span>
        <span>◎ Prep</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>

  <!-- ================================================================
       ROW 2: CHALLENGE DETAIL
       ================================================================ -->
  <div class="row-label">Challenge</div>

  <!-- FITBIT CHALLENGE -->
  <div class="phone">
    <div class="fit">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="title">Shift Challenge</div>
      <div class="sub">The Grove Signature Greeting</div>
      <div class="card">
        <div class="ct">Today's Goal</div>
        <div class="cv">Welcome 5 guests with The Grove's signature greeting</div>
        <div class="cs">3 of 5 completed this shift</div>
      </div>
      <div style="display:flex;justify-content:center;gap:12px;padding:16px 24px">
        <div style="width:40px;height:40px;border-radius:50%;background:#00B0B9;display:flex;align-items:center;justify-content:center;font-size:18px;color:#fff">✓</div>
        <div style="width:40px;height:40px;border-radius:50%;background:#00B0B9;display:flex;align-items:center;justify-content:center;font-size:18px;color:#fff">✓</div>
        <div style="width:40px;height:40px;border-radius:50%;background:#00B0B9;display:flex;align-items:center;justify-content:center;font-size:18px;color:#fff">✓</div>
        <div style="width:40px;height:40px;border-radius:50%;background:#E6F6F7;display:flex;align-items:center;justify-content:center;font-size:18px;color:#ccc">4</div>
        <div style="width:40px;height:40px;border-radius:50%;background:#E6F6F7;display:flex;align-items:center;justify-content:center;font-size:18px;color:#ccc">5</div>
      </div>
      <div class="list-item">
        <div class="icon teal">✓</div>
        <div class="text"><div class="t1">Greeting moment</div><div class="t2">11:23 AM</div></div>
        <div class="right teal">+40 XP</div>
      </div>
      <div class="list-item">
        <div class="icon teal">✓</div>
        <div class="text"><div class="t1">Greeting moment</div><div class="t2">11:51 AM</div></div>
        <div class="right teal">+40 XP</div>
      </div>
      <div class="list-item">
        <div class="icon teal">✓</div>
        <div class="text"><div class="t1">Greeting moment</div><div class="t2">12:15 PM</div></div>
        <div class="right teal">+40 XP</div>
      </div>
      <div class="list-item">
        <div class="icon gray">4</div>
        <div class="text"><div class="t1">Pending</div><div class="t2">—</div></div>
        <div class="right">+40 XP</div>
      </div>
      <div class="list-item" style="border:none">
        <div class="icon gray">5</div>
        <div class="text"><div class="t1">Pending</div><div class="t2">—</div></div>
        <div class="right">+40 XP</div>
      </div>
      <div class="card" style="background:#E6F6F7;border:1px solid #C5E8EA;text-align:center">
        <div style="font-size:13px;font-weight:600;color:#008C94">Complete all 5 → earn 200 XP toward your free coffee ☕</div>
      </div>
      <div class="card">
        <div class="ct">Why this matters</div>
        <div class="cs">The Grove's greeting is what makes guests feel at home. It's the first impression — and guests who feel welcomed tip more and come back more often.</div>
      </div>
      <div class="nav">
        <span class="on">◉ Home</span>
        <span>◎ Prep</span>
        <span>◎ Stats</span>
      </div>
    </div>
  </div>

  <!-- STRAVA CHALLENGE -->
  <div class="phone">
    <div class="stv">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="hero orange">
        <div class="tag">Shift Segment</div>
        <h2>The Grove Greeting</h2>
        <div class="sub">Welcome 5 guests with the signature greeting</div>
      </div>
      <div style="padding:16px 20px 0;display:flex;align-items:baseline;gap:8px">
        <span style="font-size:40px;font-weight:900;color:#FC4C02">3</span>
        <span style="font-size:16px;font-weight:600;color:#888">of 5</span>
      </div>
      <div style="padding:4px 20px 16px">
        <div class="seg-bar" style="margin:0"><div class="fill" style="width:60%"></div></div>
      </div>
      <div style="margin:0 16px 8px;background:rgba(252,76,2,0.1);border-radius:10px;padding:10px 14px;display:flex;align-items:center;gap:8px">
        <span style="font-size:16px">🏅</span>
        <span style="font-size:12px;font-weight:700;color:#FC4C02">Personal Record: 5/5 — last Tuesday</span>
      </div>
      <div class="label">Effort Timeline</div>
      <div class="row-item">
        <div class="ri-icon orange">✓</div>
        <div class="text"><div class="t1">Greeting moment</div><div class="t2">11:23 AM</div></div>
        <div class="right">+40 XP</div>
      </div>
      <div class="row-item">
        <div class="ri-icon orange">✓</div>
        <div class="text"><div class="t1">Greeting moment</div><div class="t2">11:51 AM</div></div>
        <div class="right">+40 XP</div>
      </div>
      <div class="row-item">
        <div class="ri-icon orange">✓</div>
        <div class="text"><div class="t1">Greeting moment</div><div class="t2">12:15 PM</div></div>
        <div class="right">+40 XP</div>
      </div>
      <div class="row-item">
        <div class="ri-icon dim">—</div>
        <div class="text"><div class="t1">Awaiting next</div><div class="t2">2 remaining</div></div>
        <div class="right" style="color:#555">+40 XP</div>
      </div>
      <div class="btn solid" style="margin-top:12px">Finish Strong — 2 Left 🔥</div>
      <div style="margin:8px 16px;background:#2C2C2E;border-radius:12px;padding:12px 16px;text-align:center;border:1px solid #3A3A3C">
        <span style="font-size:12px;color:#888">Complete all 5 →</span>
        <span style="font-size:12px;font-weight:700;color:#FC4C02"> 200 XP + ☕ progress</span>
      </div>
      <div class="nav">
        <span class="on">◉ Home</span>
        <span>◎ Prep</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS CHALLENGE -->
  <div class="phone">
    <div class="snk">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="gradient pk" style="text-align:center">
        <span class="emoji-lg">👋</span>
        <h2>The Grove Greeting</h2>
        <div class="sub">Welcome 5 guests with your best hello!</div>
      </div>
      <div class="stamp-row">
        <div class="stamp done">✓</div>
        <div class="stamp done">✓</div>
        <div class="stamp done">✓</div>
        <div class="stamp empty">☆</div>
        <div class="stamp empty">☆</div>
      </div>
      <div class="reward-card">
        <span class="emoji">⭐</span>
        <div class="title">Finish all 5 → Shift Star badge + 200 XP!</div>
        <div class="sub">You're 2 away from unlocking it</div>
      </div>
      <div class="section-title">Your Moments ✨</div>
      <div class="feed">
        <div class="emoji">✅</div>
        <div class="text"><div class="t1">Greeting moment — 11:23 AM</div><div class="t2">+40 XP</div></div>
      </div>
      <div class="feed">
        <div class="emoji">✅</div>
        <div class="text"><div class="t1">Greeting moment — 11:51 AM</div><div class="t2">+40 XP</div></div>
      </div>
      <div class="feed">
        <div class="emoji">✅</div>
        <div class="text"><div class="t1">Greeting moment — 12:15 PM</div><div class="t2">+40 XP</div></div>
      </div>
      <div class="feed" style="border:2px dashed #FFE0EC">
        <div class="emoji">⏳</div>
        <div class="text"><div class="t1">2 more to go!</div><div class="t2">You've got this — personal best was 5/5 🏅</div></div>
      </div>
      <div class="gradient soft" style="text-align:center;margin-top:4px;padding:14px">
        <div style="font-size:13px;font-weight:700;color:#FF2D78">Why this challenge?</div>
        <div style="font-size:12px;color:#999;margin-top:4px;font-weight:500">A great welcome makes every guest feel like a regular. It's the heart of what The Grove is about.</div>
      </div>
      <div class="nav">
        <span class="on">◉ Home</span>
        <span>◎ Prep</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>

  <!-- ================================================================
       ROW 3: YOUR STATS (PRIVATE — NOT LEADERBOARD)
       ================================================================ -->
  <div class="row-label">Your Stats</div>

  <!-- FITBIT STATS -->
  <div class="phone">
    <div class="fit">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="title">Your Performance</div>
      <div class="sub">Private · Only you can see this</div>
      <div style="display:flex;gap:0;margin:8px 24px;background:#f0f0f0;border-radius:8px;overflow:hidden">
        <button style="flex:1;padding:8px;border:none;background:#fff;font-size:12px;font-weight:600;color:#00B0B9;box-shadow:0 1px 4px rgba(0,0,0,0.06);font-family:'Inter',sans-serif;cursor:pointer">This Week</button>
        <button style="flex:1;padding:8px;border:none;background:transparent;font-size:12px;font-weight:600;color:#aaa;font-family:'Inter',sans-serif;cursor:pointer">This Month</button>
        <button style="flex:1;padding:8px;border:none;background:transparent;font-size:12px;font-weight:600;color:#aaa;font-family:'Inter',sans-serif;cursor:pointer">All Time</button>
      </div>
      <div style="padding:8px 24px 0;font-size:12px;font-weight:600;color:#aaa;text-transform:uppercase;letter-spacing:0.5px">Challenge Completion Rate</div>
      <div class="mini-graph">
        <div class="gbar on" style="height:60%"></div>
        <div class="gbar on" style="height:75%"></div>
        <div class="gbar on" style="height:55%"></div>
        <div class="gbar hi" style="height:100%"></div>
        <div class="gbar on" style="height:70%"></div>
        <div class="gbar on" style="height:80%"></div>
        <div class="gbar on" style="height:60%"></div>
      </div>
      <div class="graph-labels"><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div>
      <div class="stats-row">
        <div class="sbox"><div class="v">78%</div><div class="l">Completion Rate</div></div>
        <div class="sbox"><div class="v">5/5</div><div class="l">Personal Best</div></div>
      </div>
      <div class="stats-row">
        <div class="sbox"><div class="v">🔥 4</div><div class="l">Current Streak</div></div>
        <div class="sbox"><div class="v">6</div><div class="l">Best Streak</div></div>
      </div>
      <div class="card">
        <div class="ct">Rewards Earned</div>
        <div style="display:flex;gap:12px;margin-top:8px;align-items:center">
          <span style="font-size:24px">☕</span>
          <div>
            <div style="font-size:14px;font-weight:700">2 free coffees redeemed</div>
            <div style="font-size:11px;color:#aaa;margin-top:2px">340 / 500 XP toward next reward</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="ct">Recent badges</div>
        <div style="display:flex;gap:12px;margin-top:8px">
          <div style="text-align:center"><span style="font-size:24px;display:block">⭐</span><span style="font-size:9px;color:#aaa">Shift Star</span></div>
          <div style="text-align:center"><span style="font-size:24px;display:block">🔥</span><span style="font-size:9px;color:#aaa">4-Day Streak</span></div>
          <div style="text-align:center"><span style="font-size:24px;display:block">👋</span><span style="font-size:9px;color:#aaa">Greeting Pro</span></div>
          <div style="text-align:center"><span style="font-size:24px;display:block">🏅</span><span style="font-size:9px;color:#aaa">PR Setter</span></div>
        </div>
      </div>
      <div class="nav">
        <span>◎ Home</span>
        <span>◎ Prep</span>
        <span class="on">◉ Stats</span>
      </div>
    </div>
  </div>

  <!-- STRAVA STATS -->
  <div class="phone">
    <div class="stv">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div style="padding:16px 20px 0;font-size:20px;font-weight:800">Your Season Stats</div>
      <div style="padding:4px 20px 8px;font-size:12px;color:#666">Private performance · Only visible to you</div>
      <div class="toggle">
        <button class="on">Week</button>
        <button>Month</button>
        <button>All Time</button>
      </div>
      <div class="label">Completion Rate By Shift</div>
      <div class="mini-graph">
        <div class="gbar on" style="height:60%"></div>
        <div class="gbar on" style="height:75%"></div>
        <div class="gbar on" style="height:55%"></div>
        <div class="gbar hi" style="height:100%"></div>
        <div class="gbar on" style="height:70%"></div>
        <div class="gbar on" style="height:80%"></div>
        <div class="gbar on" style="height:60%"></div>
      </div>
      <div class="graph-labels"><span>Mon</span><span>Tue ★</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div>
      <div class="stat-grid" style="margin-top:8px">
        <div class="stat-card"><div class="v orange">78%</div><div class="l">Completion</div></div>
        <div class="stat-card"><div class="v orange">5/5</div><div class="l">Personal Record</div></div>
        <div class="stat-card"><div class="v orange">🔥 4</div><div class="l">Current Streak</div></div>
        <div class="stat-card"><div class="v">6</div><div class="l">Best Streak</div></div>
      </div>
      <div class="label">Rewards</div>
      <div style="margin:0 16px;background:#2C2C2E;border-radius:12px;padding:14px 16px;border:1px solid #3A3A3C">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
          <span style="font-size:13px;font-weight:700">☕ Free Coffee</span>
          <span style="font-size:11px;color:#FC4C02;font-weight:700">340 / 500 XP</span>
        </div>
        <div style="height:6px;background:#3A3A3C;border-radius:3px;overflow:hidden"><div style="width:68%;height:100%;background:#FC4C02;border-radius:3px"></div></div>
        <div style="font-size:10px;color:#666;margin-top:6px">2 rewards redeemed so far</div>
      </div>
      <div class="label">Badges</div>
      <div style="display:flex;gap:12px;padding:0 20px">
        <div style="text-align:center"><span style="font-size:24px;display:block">⭐</span><span style="font-size:9px;color:#666">Shift Star</span></div>
        <div style="text-align:center"><span style="font-size:24px;display:block">🔥</span><span style="font-size:9px;color:#666">Streak 4</span></div>
        <div style="text-align:center"><span style="font-size:24px;display:block">🏅</span><span style="font-size:9px;color:#666">PR Setter</span></div>
        <div style="text-align:center"><span style="font-size:24px;display:block">👋</span><span style="font-size:9px;color:#666">Greeter</span></div>
        <div style="text-align:center;opacity:0.3"><span style="font-size:24px;display:block">👑</span><span style="font-size:9px;color:#666">Week King</span></div>
      </div>
      <div class="nav">
        <span>◎ Home</span>
        <span>◎ Prep</span>
        <span class="on">◉ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS STATS -->
  <div class="phone">
    <div class="snk">
      <div class="bar"><span>11:48 AM</span><span>LTE &nbsp; 88%</span></div>
      <div class="section-title">Your Highlights ✨</div>
      <div style="padding:0 20px 8px;font-size:12px;color:#999;font-weight:500">Your data, your story. Only you can see this.</div>
      <div class="qs-grid">
        <div class="qs"><div class="v">78%</div><div class="l">Completion</div></div>
        <div class="qs"><div class="v">🔥 4</div><div class="l">Day Streak</div></div>
        <div class="qs"><div class="v">5/5</div><div class="l">Best Shift 🥇</div></div>
      </div>
      <div style="padding:8px 20px 4px;font-size:12px;font-weight:700;color:#999">This Week</div>
      <div class="mini-graph">
        <div class="gbar on" style="height:60%"></div>
        <div class="gbar on" style="height:75%"></div>
        <div class="gbar on" style="height:55%"></div>
        <div class="gbar hi" style="height:100%"></div>
        <div class="gbar on" style="height:70%"></div>
        <div class="gbar on" style="height:80%"></div>
        <div class="gbar on" style="height:60%"></div>
      </div>
      <div class="graph-labels"><span>Mon</span><span>Tue ⭐</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div>
      <div class="section-title">Level Up! 🚀</div>
      <div style="padding:0 20px 4px;font-size:12px;font-weight:600;color:#999">Level 7 · 340 / 500 XP</div>
      <div class="level-bar" style="background:#FFF0F5"><div class="fill" style="width:68%;background:linear-gradient(90deg,#FF2D78,#FFD600)"></div></div>
      <div style="padding:6px 20px 0;font-size:11px;color:#999;font-weight:500;text-align:center">160 XP to Level 8 → ☕ Free coffee!</div>
      <div class="section-title">Badges Collected 🎖️</div>
      <div style="display:flex;gap:8px;padding:0 16px;flex-wrap:wrap">
        <div style="background:#FFF5F8;border:2px solid #FFE0EC;border-radius:16px;padding:10px;text-align:center;width:72px">
          <span style="font-size:24px;display:block">⭐</span><span style="font-size:9px;font-weight:700;color:#FF2D78">Shift Star</span>
        </div>
        <div style="background:#FFF5F8;border:2px solid #FFE0EC;border-radius:16px;padding:10px;text-align:center;width:72px">
          <span style="font-size:24px;display:block">🔥</span><span style="font-size:9px;font-weight:700;color:#FF2D78">Streak 4</span>
        </div>
        <div style="background:#FFF5F8;border:2px solid #FFE0EC;border-radius:16px;padding:10px;text-align:center;width:72px">
          <span style="font-size:24px;display:block">🏅</span><span style="font-size:9px;font-weight:700;color:#FF2D78">PR Setter</span>
        </div>
        <div style="background:#FFF5F8;border:2px solid #FFE0EC;border-radius:16px;padding:10px;text-align:center;width:72px">
          <span style="font-size:24px;display:block">👋</span><span style="font-size:9px;font-weight:700;color:#FF2D78">Greeter</span>
        </div>
        <div style="background:#f5f5f5;border:2px dashed #ddd;border-radius:16px;padding:10px;text-align:center;width:72px;opacity:0.4">
          <span style="font-size:24px;display:block">👑</span><span style="font-size:9px;font-weight:700;color:#999">???</span>
        </div>
      </div>
      <div class="feed" style="margin-top:10px">
        <div class="emoji">☕</div>
        <div class="text"><div class="t1">2 free coffees redeemed!</div><div class="t2">Keep going — next one is 160 XP away</div></div>
      </div>
      <div class="nav">
        <span>◎ Home</span>
        <span>◎ Prep</span>
        <span class="on">◉ Me</span>
      </div>
    </div>
  </div>

  <!-- ================================================================
       ROW 4: PRE-SHIFT PREP
       ================================================================ -->
  <div class="row-label">Pre-Shift Prep</div>

  <!-- FITBIT PREP -->
  <div class="phone">
    <div class="fit">
      <div class="bar"><span>10:45 AM</span><span>LTE &nbsp; 91%</span></div>
      <div class="title">Tonight's Briefing</div>
      <div class="sub">Get prepped before your shift</div>
      <div class="card" style="border:1px solid #C5E8EA">
        <div class="ct">🍽️ Chef's Special</div>
        <div class="cv" style="font-size:18px">Pan-Seared Halibut</div>
        <div class="cs" style="margin-top:8px;line-height:1.5">Locally caught halibut with lemon-herb butter, roasted fingerlings, and seasonal greens. Gluten-free.</div>
      </div>
      <div style="padding:12px 24px 4px;font-size:12px;font-weight:600;color:#aaa;text-transform:uppercase;letter-spacing:0.5px">Suggested Pairings</div>
      <div class="list-item">
        <div class="icon teal">🍷</div>
        <div class="text"><div class="t1">Sancerre (white wine)</div><div class="t2">Crisp, mineral — complements the lemon butter</div></div>
      </div>
      <div class="list-item" style="border:none">
        <div class="icon teal">🥂</div>
        <div class="text"><div class="t1">Sparkling Rosé</div><div class="t2">Light and festive — great for celebrations</div></div>
      </div>
      <div class="divider"></div>
      <div style="padding:12px 24px 4px;font-size:12px;font-weight:600;color:#aaa;text-transform:uppercase;letter-spacing:0.5px">Quick Quiz · +50 XP</div>
      <div class="quiz-q">What pairs best with tonight's halibut special?</div>
      <div class="quiz-opt">A. Cabernet Sauvignon</div>
      <div class="quiz-opt" style="border-color:#00B0B9;background:#F0FAFA">B. Sancerre</div>
      <div class="quiz-opt">C. Pinot Noir</div>
      <div class="quiz-opt">D. Malbec</div>
      <div class="btn primary" style="margin-top:12px">Start Shift →</div>
      <div class="nav">
        <span>◎ Home</span>
        <span class="on">◉ Prep</span>
        <span>◎ Stats</span>
      </div>
    </div>
  </div>

  <!-- STRAVA PREP -->
  <div class="phone">
    <div class="stv">
      <div class="bar"><span>10:45 AM</span><span>LTE &nbsp; 91%</span></div>
      <div class="hero dark">
        <div class="tag">Pre-Race Briefing</div>
        <h2>Know Your Course</h2>
        <div class="sub">Get race-ready before you clock in</div>
      </div>
      <div class="label">🍽️ Tonight's Featured Dish</div>
      <div style="margin:0 16px 8px;background:#2C2C2E;border-radius:12px;padding:16px;border:1px solid #3A3A3C">
        <div style="font-size:18px;font-weight:800;margin-bottom:6px">Pan-Seared Halibut</div>
        <div style="font-size:12px;color:#888;line-height:1.5">Locally caught halibut, lemon-herb butter, roasted fingerlings, seasonal greens. Gluten-free.</div>
      </div>
      <div class="label">Segments to Watch</div>
      <div class="row-item">
        <div class="ri-icon orange">🍷</div>
        <div class="text"><div class="t1">Sancerre</div><div class="t2">Crisp, mineral — complements the lemon butter</div></div>
        <div class="pill orange">Pair</div>
      </div>
      <div class="row-item">
        <div class="ri-icon orange">🥂</div>
        <div class="text"><div class="t1">Sparkling Rosé</div><div class="t2">Light and festive — great for celebrations</div></div>
        <div class="pill orange">Pair</div>
      </div>
      <div class="label">🧠 Warm Up Quiz · +50 XP</div>
      <div class="quiz-q">What pairs best with tonight's halibut special?</div>
      <div class="quiz-opt">A. Cabernet Sauvignon</div>
      <div class="quiz-opt" style="border-color:#FC4C02">B. Sancerre</div>
      <div class="quiz-opt">C. Pinot Noir</div>
      <div class="quiz-opt">D. Malbec</div>
      <div class="btn solid" style="margin-top:16px">Ready to Run 🏁</div>
      <div class="nav">
        <span>◎ Home</span>
        <span class="on">◉ Prep</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS PREP -->
  <div class="phone">
    <div class="snk">
      <div class="bar"><span>10:45 AM</span><span>LTE &nbsp; 91%</span></div>
      <div class="gradient yl" style="text-align:center">
        <span class="emoji-lg">🍽️</span>
        <h2>Know Your Menu!</h2>
        <div class="sub" style="color:#7a6800">Get prepped, earn XP, impress your guests</div>
      </div>
      <div class="section-title">Tonight's Star Dish ⭐</div>
      <div class="feed" style="background:#FFF9E6;border:2px solid #FFD600">
        <div class="emoji">🐟</div>
        <div class="text">
          <div class="t1">Pan-Seared Halibut</div>
          <div class="t2">Lemon-herb butter, roasted fingerlings, seasonal greens · GF</div>
        </div>
      </div>
      <div class="section-title">Perfect Pairings 🍷</div>
      <div class="bubble-row" style="justify-content:flex-start;padding-left:20px">
        <div class="bub pk">🍷 Sancerre</div>
        <div class="bub yl">🥂 Sparkling Rosé</div>
      </div>
      <div style="padding:4px 24px 0;font-size:11px;color:#999;font-weight:500">Crisp wines that complement the lemon-herb butter</div>
      <div class="section-title">Quiz Time! 🧠 · +50 XP</div>
      <div class="quiz-q">What pairs best with tonight's halibut special?</div>
      <div class="quiz-opt">A. Cabernet Sauvignon 🍇</div>
      <div class="quiz-opt" style="border-color:#FF2D78;background:#FFF0F5">B. Sancerre 🍷 ✓</div>
      <div class="quiz-opt">C. Pinot Noir 🍇</div>
      <div class="quiz-opt">D. Malbec 🍇</div>
      <div class="btn pk" style="margin-top:12px">I'm Ready! 🚀</div>
      <div class="nav">
        <span>◎ Home</span>
        <span class="on">◉ Prep</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>

</div>

<p class="footer">Concept mockups for design partner discussion — March 2026.<br>Based on server interviews with Jenna and Tara.</p>

</body>
</html>`;

export default bespokeServerAppMockups4Html;
